import React from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    CircularProgress,
    Box,
} from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#7e7e7e",
        color: theme.palette.common.white,
        textTransform: "capitalize",
        fontSize: 16,
        fontWeight: 600,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textTransform: "capitalize",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd),&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const CoderDistributionTable = ({
    data,
    loading
}) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const paginatedRows = data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const totals = data?.reduce((acc, lab) => {
      acc.lab_strength_Count += lab.lab_strength;
      acc.regular_practices_started_Count += lab.regular_practices_started;
      acc.fast_practices_started_Count += lab.fast_practices_started;
      acc.slow_practices_started_Count += lab.slow_practices_started;
      return acc;
    }, {
      lab_strength_Count: 0,
      regular_practices_started_Count: 0,
      fast_practices_started_Count: 0,
      slow_practices_started_Count: 0
    });
        
    return (
        <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
            <Table sx={{ tableLayout: "auto", width: "max-content", minWidth:"100%" }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Lab Name</StyledTableCell>
                        <StyledTableCell>Lab Strength ({totals?.lab_strength_Count ||0})</StyledTableCell>
                        <StyledTableCell>#Fast Coder ({totals?.fast_practices_started_Count ||0})</StyledTableCell>
                        <StyledTableCell>#Regular Coder ({totals?.regular_practices_started_Count ||0})</StyledTableCell>
                        <StyledTableCell>#Slow Coder ({totals?.slow_practices_started_Count ||0})</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? (
                        <TableRow>
                            <StyledTableCell colSpan={7} align="center">
                                <Box display="flex" justifyContent="center" alignItems="center" height="30px">
                                    <CircularProgress />
                                </Box>
                            </StyledTableCell>
                        </TableRow>
                    ) : paginatedRows?.length > 0 ? (
                        paginatedRows.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell>{row?.lab_name || "-"}</StyledTableCell>
                                <StyledTableCell>{row?.lab_strength || 0}</StyledTableCell>
                                <StyledTableCell>{row?.fast_practices_started || 0}</StyledTableCell>
                                <StyledTableCell>{row?.regular_practices_started || 0}</StyledTableCell>
                                <StyledTableCell>{row?.slow_practices_started || 0}</StyledTableCell>
                            </StyledTableRow>
                        ))
                    ) : (
                        <StyledTableRow>
                            <StyledTableCell sx={{ fontWeight: "600", color: "grey" }} colSpan={9} align="center">
                                No coder distribution records found.
                            </StyledTableCell>
                        </StyledTableRow>
                    )
                    }
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[10,20,30,60,100]}
                component="div"
                count={data?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </TableContainer>
    );
};
export default CoderDistributionTable;
